import React, { useState, useEffect } from 'react';

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    // Auto close the toast after 3 seconds
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    
    return () => clearTimeout(timer); // Clean up the timer
  }, [onClose]);

  return (
    <div
      className={`fixed top-4 right-4 w-72 p-4 rounded-lg shadow-md transition-all duration-300 ease-in-out ${
        type === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'
      }`}
    >
      <div className="flex justify-between items-center">
        <span>{message}</span>
        <button onClick={onClose} className="ml-2 text-xl font-bold">
          &times;
        </button>
      </div>
    </div>
  );
};

export default Toast;
